import { Subscription } from 'rxjs/Subscription';
import { AdminProvider } from './../../providers/admin/admin';
import { User } from './../../models/User';
import { Component, Input } from '@angular/core';

/**
 * Generated class for the AdminUserDetailsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'admin-user-details',
  templateUrl: 'admin-user-details.html'
})
export class AdminUserDetailsComponent {
  @Input('user') user: User;

  isAdmin: boolean = false;
  sub: Subscription;
  constructor(
    private admin: AdminProvider
  ) {
    this.sub = admin.getAdminUids().subscribe(uids =>{
      this.setIsAdmin(uids);
    })
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  private setIsAdmin(uids: string[]){
    for(let uid of uids){
      if(this.user.uid == uid){
        this.isAdmin = true;
        return;
      }
    }
    this.isAdmin = false;
  }

  makeAdmin(){
    if(this.user.uid){
      this.admin.addAdmin(this.user.uid);
    }
  }

  revokeAdmin(){
    if(this.user.uid){
      this.admin.removeAdmin(this.user.uid);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/admin-user-details/admin-user-details.ts